import { c as _c } from "react/compiler-runtime";
import { HotelCardStars } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars";
import { HotelReserveDetailsPropertiesTypes } from "@website/accommodation-ui/hotel-reserve-details/hotel-reserve-details.types";
import { MaterialIcon } from "@website/icons/material";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { isRtl } from "@website/utils/is-rtl";
import { numberConvert } from "@website/utils/number-convert";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
export const HotelReserveDetails = properties => {
  const $ = _c(24);
  const {
    hotelTitle,
    stars,
    address,
    description
  } = properties;
  const router = useRouter();
  const t0 = isRtl(hotelTitle) ? "rtl" : "ltr";
  let t1;
  if ($[0] !== hotelTitle || $[1] !== router) {
    t1 = isRtl(hotelTitle) ? numberConvert(hotelTitle, {
      locale: router.locale
    }) : toString(hotelTitle);
    $[0] = hotelTitle;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = <h1 className="pb-1 text-base font-semibold leading-6 lg:pb-4 lg:text-lg xl:text-2xl" dir={t0}>{t1}</h1>;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isRtl(address) ? "rtl" : "ltr";
  let t4;
  if ($[6] !== stars) {
    t4 = Boolean(stars) && <><div className="hidden lg:block" itemScope={true}><HotelCardStars color="neutral" starSize="medium" stars={stars || 0} /></div><div className="block lg:hidden" itemScope={true}><HotelCardStars color="neutral" starSize="small" stars={stars || 0} /></div></>;
    $[6] = stars;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== address || $[9] !== router) {
    t5 = address && <div className="flex flex-row gap-1"><div className=""><MaterialIcon name="location_on" variant="outlined" /></div><div>{isRtl(address) ? numberConvert(address.replaceAll(".", ""), {
          locale: router.locale
        }) : toString(address)}</div></div>;
    $[8] = address;
    $[9] = router;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className="text-on-surface-medium-emphasis text-caption lg:text-body-1 flex flex-col items-start gap-1 lg:flex-row lg:items-center lg:gap-4" dir={t3}>{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== description || $[16] !== router) {
    t7 = description && <div dir={isRtl(description) ? "rtl" : "ltr"}><CollapsibleText ariaLabel="details" collapsedClassName="h-[40px] md:h-[50px]" content={<p className="text-on-surface-high-emphasis text-body-2 lg:text-body-1 text-justify" dangerouslySetInnerHTML={{
        __html: isRtl(description) ? numberConvert(description, {
          locale: router.locale
        }) : toString(description)
      }} />} lessText={"\u0628\u0633\u062A\u0646"} lessTextIcon={<MaterialIcon name="arrow_drop_up" />} moreText={"\u0645\u0634\u0627\u0647\u062F\u0647 \u0628\u06CC\u0634\u062A\u0631"} moreTextIcon={<MaterialIcon name="arrow_drop_down" />} /></div>;
    $[15] = description;
    $[16] = router;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="flex flex-col gap-6">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t8) {
    t9 = <div className="max-w-[1200px] pt-6">{t2}{t8}</div>;
    $[21] = t2;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};